import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { countries } from 'countries-list';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { BaseControlValueAccessor } from '../../form-input-components/base-control-value-accessor';
import { FormatPhoneNumberPipe } from '../../pipes/format-phone-number.pipe';
import { indiaPhoneValidator, phoneValidator } from '../../validators/phone-validator';
import { AddRiderService } from '../../services/add-rider.service';

@Component({
  selector: 'app-phone-input-component',
  templateUrl: './phone-input-component.component.html',
  styleUrls: ['./phone-input-component.component.scss']
})
export class PhoneInputComponentComponent extends BaseControlValueAccessor<string> implements OnInit, AfterViewInit {
  @Input() formControls: any;
  @Input() config: any;
  @Input() inputFormControlNumber: FormControl;
  @Input() inputFormControlCode: FormControl;
  @Output() onCodeChange = new EventEmitter();
  @Input() dropdownWidth:any
  @Input() maskEnable:boolean
  @Input() riderForm:any
  @Input() disable:boolean;
  @Input() elementKey:string
  @Input() editBookingMode:boolean
  dropdownData: DropdownItem[] = [];
  SelectedValue: DropdownItem = {label: '+91', value: '+91'};
  errorState = false;
  randomId = null;

  constructor(private formatPhone: FormatPhoneNumberPipe, private addRiderService:AddRiderService){
    super();
    this.randomId = Math.random().toString();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.disable?.currentValue){
        this.inputFormControlNumber.disable();
    }else if(!changes.disable?.currentValue){
      this.inputFormControlNumber.enable();
    }
    this.inputFormControlNumber?.value && changes.maskEnable?.currentValue ?  this.setMasking() :  this.inputFormControlNumber.enable();
  }


  ngOnInit(): void {
    Object.values(countries).map(item => {
      this.SelectedValue = item.phone === "91" && { label: (item.emoji + " +" + item.phone) as any, value: item.phone };
      this.dropdownData.push({ label: (item.emoji + " +" + item.phone) as any, value: item.phone });
    });
    // this.dropdownData = Object.values(countries).map((item: any) => ({
    //   label: `+ ${item.phone} ${item.name}`,
    //   value: item.phone
    // }))
    // this.SelectedValue={label:'+'+this.inputFormControlCode.value,value:this.inputFormControlCode.value}
    if (this.inputFormControlNumber.value == "")
    {
      this.onCodeChange.emit(this.inputFormControlNumber.value == "" ? "91" : this.inputFormControlNumber.value);

    }
    if (this.inputFormControlCode.value !== "")
    {
     const item = Object.values(countries).find(item => item.phone === this.inputFormControlCode?.value.split("+")[this.inputFormControlCode.value.split("+").length - 1]);
      this.SelectedValue = { label: item.emoji + " +" + item.phone, value: item.phone };
    }


    if(this.riderForm){
      this.inputFormControlNumber.valueChanges.subscribe(input=>{
        if(this.elementKey=='alternateMobile') 
          this.addRiderService.alternateMobileMandatory ? this.inputFormControlCode.value=='+91' ?  this.inputFormControlNumber.setValidators([Validators.required,indiaPhoneValidator]) :  this.inputFormControlNumber.setValidators([Validators.required,phoneValidator]) : this.inputFormControlNumber.setValidators(null)
        else
          this.inputFormControlCode.value=='+91' ?  this.inputFormControlNumber.setValidators([Validators.required,indiaPhoneValidator]) :  this.inputFormControlNumber.setValidators([Validators.required,phoneValidator])        
    }) 
    }
  }

  ngAfterViewInit(): void {
      this.setMasking();
  }


  countryCodeSelection($event)
  {
      this.SelectedValue = $event;
      this.onCodeChange.emit($event.value);
  }
  getDriverPhone(e){
    const inputValue = e.target.value;
    const numericOnly = inputValue.replace(/\D/g, '');

    // form.value=numericOnly.toString()

  }

  showError(): boolean {
    if (this.inputFormControlNumber.errors && this.inputFormControlNumber.errors.secure) {
      return false;
    } else {
      this.errorState = Boolean(this.inputFormControlNumber && this.inputFormControlNumber.errors && this.inputFormControlNumber.dirty);
      return Boolean(this.inputFormControlNumber && this.inputFormControlNumber.errors && this.inputFormControlNumber.dirty);
    }
  }
  setMasking(){
    let element : any = document.getElementById(this.randomId);
      if(element && this.maskEnable){
      element = element.getElementsByTagName('input')[0];
      element.type = 'text';
      this.riderForm.controls[0].get(this.elementKey).setValidators(null);
      const value = this.formatPhone.transform(this.inputFormControlNumber.value,this.riderForm.value[0]);
      if(value !== this.inputFormControlNumber.value){
        element.value = value;
        this.inputFormControlNumber.disable();
      }
  }else{
    this.disable ?  this.inputFormControlNumber.disable() : this.inputFormControlNumber.enable();
  }
}

}
